import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import { createEpicMiddleware } from "redux-observable";
import { IAction } from "../interface/action.interface";
import { rootEpic } from "./root.epic";
import reducer, { IRootState } from "./root.reducer";

// TODO: Yet to decide
const preloadedState = {};
const { NODE_ENV: env } = process.env;

const epicMiddleware = createEpicMiddleware<IAction, IAction, IRootState>();

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(epicMiddleware),
    devTools: env !== "production",
    preloadedState,
});

epicMiddleware.run(rootEpic);

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
type AppDispatch = typeof store.dispatch;

// It saves the need to type (state: RootState) every time
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector;

export default store;
